/**
 * Shortcuts to the operational pages. These are navigations only: the old buttons promised an
 * export and a report that no endpoint produces, and did nothing when pressed.
 */

import type { ReactNode } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Button, Grid, Paper, Typography } from '@mui/material'
import {
  Analytics,
  BugReport,
  Build,
  ConfirmationNumber,
  People,
  ReceiptLong,
  Speed,
} from '@mui/icons-material'

const ACTIONS: { to: string; label: string; icon: ReactNode }[] = [
  { to: '/users', label: 'Users', icon: <People /> },
  { to: '/tickets', label: 'Tickets', icon: <ConfirmationNumber /> },
  { to: '/statistics', label: 'Statistics', icon: <Analytics /> },
  { to: '/performance', label: 'Performance', icon: <Speed /> },
  { to: '/crashes', label: 'Crashes', icon: <BugReport /> },
  { to: '/logs', label: 'Logs', icon: <ReceiptLong /> },
  { to: '/tools', label: 'Tools', icon: <Build /> },
]

export function QuickActionsPanel() {
  return (
    <Paper sx={{ p: { xs: 1.5, sm: 2 } }}>
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Go to
      </Typography>
      <Grid container spacing={1}>
        {ACTIONS.map((a) => (
          <Grid item xs={6} sm={4} md={3} key={a.to}>
            <Button
              component={RouterLink}
              to={a.to}
              variant="outlined"
              fullWidth
              startIcon={a.icon}
              sx={{ minHeight: 44, justifyContent: 'flex-start' }}
            >
              {a.label}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Paper>
  )
}
